export default {
  usage: 'Použitie',
  parameters: 'Parametre',
  body: 'Obsah',
  bodyHint: 'Ak chcete použiť predvolený obsah, nechajte obsah prázdny. Zmenený obsah platí pre každý report.',
  copyDefaultBody: 'Kopírovať predvolený obsah',
  resetBody: 'Použiť predvolený obsah',
};
